<template>
  <div  class="bg-white ">
    <div class="flex align-center justify-between">
      <threeLevel @SearchInfo="SearchInfo" :biaozhang="1"/>

      <el-button type="primary" @click="addCommendDialog = true">新增</el-button>
    </div>

    <el-table
      class="margin-top"
      :data="infoList"
      header-row-class-name="table-header"
      row-class-name="table-row"
      alig="center"
      border
      style="width: 100%"
    >
      <el-table-column width="70" type="index" align="center" label="序号">
      </el-table-column>
      <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
      <el-table-column label="志愿者队长" prop="yuangong_name"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <div>
            {{ scope.row.type === 1 ? "表彰" : "投诉" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="原由" prop="content"></el-table-column>
      <el-table-column label="时间" prop="create_time"></el-table-column>
      <el-table-column label="操作" >
        <template slot-scope="scope">
          <div class="table-operate">
            <el-button
              size="small"
              type="primary"
              @click="deleteItem(scope.row.id)"
            >删除
            </el-button>

          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="infoList.length > 0"
      class="page-all"
      background
      @current-change="getList"
      :current-page.sync="page"
      :page-size="limit"
      layout="prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <addCommendDialog :addCommendDialog="addCommendDialog" @cancelDialog="cancelDialog"/>
  </div>
</template>

<script>
import threeLevel from "@/components/three-level";
import addCommendDialog from "@/views/pages/dialog/addCommendDialog";
import {delAdminComment, getAdminCommentList} from "@/api/biaozhang";
export default {
  name: "commend-complaint",
  data() {
    return {
      infoList:[],
      project: 0,
      community: 0,
      yuangong: 0,
      type:0,
      page: 1,
      limit: 10,
      total: 0,
      addCommendDialog:false
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "表彰投诉", false);
  },
  components: {
    threeLevel,
    addCommendDialog
  },
  methods: {
    async getList(){
      let _list = await getAdminCommentList(this.community,this.yuangong,'','','',this.type,this.page,this.limit)
      this.infoList = _list.data
      this.total = _list.total_number
    },
    SearchInfo(val){
      if(val){
        this.project = val.project
        this.community = val.community
        this.yuangong = val.yuangong
        this.type = val.type
        this.page = 1
      }
      this.getList()
    },
    cancelDialog() {
      this.addCommendDialog = false
      this.getList()
    },
    //  删除账号
    deleteItem(id){
      this.$confirm('您确定要删除该信息吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await delAdminComment(id);
      if (this.infoList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.info);
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
